import gql from 'graphql-tag';
import FieldsTimeslotKindException from 'graphql/fields/FieldsTimeslotKindException'
import HelperGraphql from 'utils/helper-graphql'
import FieldsTimeslotKind from 'graphql/fields/FieldsTimeslotKind'

const fields = {
	'timeslot_kind_guid': 'String',
	'active': '[String]',
};

export default gql(`
	query timeslot_kind_exceptions( ${ HelperGraphql.createFields( fields ) } ) {
		timeslot_kind_exceptions( ${ HelperGraphql.createVariables( fields ) } ) {
			${ FieldsTimeslotKindException }
			
			timeslot_kind {
				${FieldsTimeslotKind}
			}
		}
	}
`);

